export const Icons = {
  magenta11yLogoDT: "magenta11yLogoDT",
  magenta11yLogoSm: "magenta11yLogoSm",
  abcOutlined: "abcOutlined",
  acPlugFilled: "acPlugFilled",
  acPlugOffFilled: "acPlugOffFilled",
  acPlugOffOutlined: "acPlugOffOutlined",
  acPlugOutlined: "acPlugOutlined",
  accelActive: "accelActive",
  accelDisabled: "accelDisabled",
  accessPointOutlined: "accessPointOutlined",
  accountGroupAddFilled: "accountGroupAddFilled",
  accountGroupAddOutlined: "accountGroupAddOutlined",
  accountGroupFilled: "accountGroupFilled",
  accountGroupOutlined: "accountGroupOutlined",
  accountGuardianFilled: "accountGuardianFilled",
  accountGuardianOutlined: "accountGuardianOutlined",
  addContactFilled: "addContactFilled",
  addContactOutlined: "addContactOutlined",
  adminFilled: "adminFilled",
  adminOutlined: "adminOutlined",
  agent: "agent",
  alarmFilled: "alarmFilled",
  alarmOffFilled: "alarmOffFilled",
  alarmOffOutlined: "alarmOffOutlined",
  alarmOutlined: "alarmOutlined",
  alarmSystemFilled: "alarmSystemFilled",
  alarmSystemOutlined: "alarmSystemOutlined",
  alignBottomOutlined: "alignBottomOutlined",
  alignLeftOutlined: "alignLeftOutlined",
  alignRightOutlined: "alignRightOutlined",
  alignTopOutlined: "alignTopOutlined",
  amexActive: "amexActive",
  amexDisabled: "amexDisabled",
  androidGpsImpreciseCenteredFilled: "androidGpsImpreciseCenteredFilled",
  androidGpsImpreciseNotcenteredOutlined: "androidGpsImpreciseNotcenteredOutlined",
  androidGpsLocationOffFilled: "androidGpsLocationOffFilled",
  androidGpsLocationOffOutlined: "androidGpsLocationOffOutlined",
  applepayActive: "applepayActive",
  applepayDisabled: "applepayDisabled",
  ar: "ar",
  arrowDownLeft: "arrowDownLeft",
  arrowDownRight: "arrowDownRight",
  arrowDown: "arrowDown",
  arrowLeft: "arrowLeft",
  arrowTopLeft: "arrowTopLeft",
  arrowTopRight: "arrowTopRight",
  arrowTop: "arrowTop",
  arrowDropDown: "arrowDropDown",
  arrowRight: "arrowRight",
  articleFilled: "articleFilled",
  articleOutlined: "articleOutlined",
  ascendingOutlined: "ascendingOutlined",
  asleepFilled: "asleepFilled",
  asleepOutlined: "asleepOutlined",
  atmActive: "atmActive",
  atmDisabled: "atmDisabled",
  audioVideoDeviceFilled: "audioVideoDeviceFilled",
  audioVideoDeviceOutlined: "audioVideoDeviceOutlined",
  awakeFilled: "awakeFilled",
  awakeOutlined: "awakeOutlined",
  babyMonitorFilled: "babyMonitorFilled",
  babyMonitorOutlined: "babyMonitorOutlined",
  badgeFilled: "badgeFilled",
  badgeOutlined: "badgeOutlined",
  bagFilled: "bagFilled",
  bagOutlined: "bagOutlined",
  bankActive: "bankActive",
  bankDisabled: "bankDisabled",
  bankFilled: "bankFilled",
  bankOutlined: "bankOutlined",
  barchart: "barchart",
  batteryChargingFilled: "batteryChargingFilled",
  batteryChargingOutlined: "batteryChargingOutlined",
  batteryEmptyFilled: "batteryEmptyFilled",
  batteryEmptyOutlined: "batteryEmptyOutlined",
  batteryFullFilled: "batteryFullFilled",
  batteryFullOutlined: "batteryFullOutlined",
  batteryHalfFilled: "batteryHalfFilled",
  batteryHalfOutlined: "batteryHalfOutlined",
  batteryLowFilled: "batteryLowFilled",
  batteryLowOutlined: "batteryLowOutlined",
  batteryOffFilled: "batteryOffFilled",
  batteryOffOutlined: "batteryOffOutlined",
  batteryQuarterFilled: "batteryQuarterFilled",
  batteryQuarterOutlined: "batteryQuarterOutlined",
  batteryThreeQuartersFilled: "batteryThreeQuartersFilled",
  batteryThreeQuartersOutlined: "batteryThreeQuartersOutlined",
  benefitsFilled: "benefitsFilled",
  benefitsOutlined: "benefitsOutlined",
  billAltFilled: "billAltFilled",
  billAltOutlined: "billAltOutlined",
  billFilled: "billFilled",
  billOutlined: "billOutlined",
  block: "block",
  bluetoothDisabledOutlined: "bluetoothDisabledOutlined",
  bluetooth: "bluetooth",
  bookmarkFilled: "bookmarkFilled",
  bookmarkOutlined: "bookmarkOutlined",
  botnetPreventionFilled: "botnetPreventionFilled",
  botnetPreventionOutlined: "botnetPreventionOutlined",
  brakeFluidLowFilled: "brakeFluidLowFilled",
  brakeFluidLowOutlined: "brakeFluidLowOutlined",
  brandLogoMagenta: "brandLogoMagenta",
  brandLogoWhite: "brandLogoWhite",
  brightnessContrastOutlined: "brightnessContrastOutlined",
  calendarFilled: "calendarFilled",
  calendarOutlined: "calendarOutlined",
  call: "call",
  cameraFilled: "cameraFilled",
  cameraOffFilled: "cameraOffFilled",
  cameraOffOutlined: "cameraOffOutlined",
  cameraOutlined: "cameraOutlined",
  carBatteryFilled: "carBatteryFilled",
  carBatteryOutlined: "carBatteryOutlined",
  carFrontFilled: "carFrontFilled",
  carFrontOutlined: "carFrontOutlined",
  carSideFilled: "carSideFilled",
  carSideOutlined: "carSideOutlined",
  cardFilled: "cardFilled",
  cardOutlined: "cardOutlined",
  caretDown: "caretDown",
  caretLeft: "caretLeft",
  caretRight: "caretRight",
  caretUp: "caretUp",
  cartFilled: "cartFilled",
  cartOutlined: "cartOutlined",
  cashFilled: "cashFilled",
  cashOutlined: "cashOutlined",
  categoryFilled: "categoryFilled",
  categoryOutlined: "categoryOutlined",
  chartFilled: "chartFilled",
  chartOutlined: "chartOutlined",
  chatFilled: "chatFilled",
  chatOutlined: "chatOutlined",
  chatReceivedFilled: "chatReceivedFilled",
  chatReceivedOutlined: "chatReceivedOutlined",
  checkCircleFilled: "checkCircleFilled",
  checkCircleOutlined: "checkCircleOutlined",
  checkboxIndeterminate: "checkboxIndeterminate",
  checkboxSelected: "checkboxSelected",
  checkboxUnselected: "checkboxUnselected",
  checklistOutlined: "checklistOutlined",
  checkmark: "checkmark",
  chevronDownSmall: "chevronDownSmall",
  chevronDown: "chevronDown",
  chevronLeftSmall: "chevronLeftSmall",
  chevronLeft: "chevronLeft",
  chevronRightSmall: "chevronRightSmall",
  chevronRight: "chevronRight",
  chevronTopSmall: "chevronTopSmall",
  chevronTop: "chevronTop",
  childFilled: "childFilled",
  childOutlined: "childOutlined",
  clipboardFilled: "clipboardFilled",
  clipboardOutlined: "clipboardOutlined",
  clockFilled: "clockFilled",
  clockOutlined: "clockOutlined",
  closeCircleFilled: "closeCircleFilled",
  closeCircleOutlined: "closeCircleOutlined",
  closeOutlined: "closeOutlined",
  cloudErrorFilled: "cloudErrorFilled",
  cloudErrorOutlined: "cloudErrorOutlined",
  cloudFilled: "cloudFilled",
  cloudOffFilled: "cloudOffFilled",
  cloudOffOutlined: "cloudOffOutlined",
  cloudOutlined: "cloudOutlined",
  compassFilled: "compassFilled",
  compassOutlined: "compassOutlined",
  contactListFilled: "contactListFilled",
  contactListOutlined: "contactListOutlined",
  contentCopy: "contentCopy",
  contentCopyFilled: "contentCopyFilled",
  copyFilled: "copyFilled",
  copyOutlined: "copyOutlined",
  cryptoMinerOutlined1: "cryptoMinerOutlined1",
  cryptoMinerOutlined: "cryptoMinerOutlined",
  debugOutlined: "debugOutlined",
  descendingOutlined: "descendingOutlined",
  digitalCameraFilled: "digitalCameraFilled",
  digitalCameraOutlined: "digitalCameraOutlined",
  directionFilled: "directionFilled",
  directionOutlined: "directionOutlined",
  discoverActive: "discoverActive",
  discoverDisabled: "discoverDisabled",
  dislikeFilled: "dislikeFilled",
  dislikeOutlined: "dislikeOutlined",
  documentAddFilled: "documentAddFilled",
  documentAddOutlined: "documentAddOutlined",
  documentFilled: "documentFilled",
  documentOutlined: "documentOutlined",
  doorbellFilled: "doorbellFilled",
  doorbellOutlined: "doorbellOutlined",
  dotMenu: "dotMenu",
  downgrade: "downgrade",
  downloadOutlined: "downloadOutlined",
  dragIndicatorOutlined: "dragIndicatorOutlined",
  driveDeviceFilled: "driveDeviceFilled",
  driveDeviceOutlined: "driveDeviceOutlined",
  driversLicense: "driversLicense",
  droneFilled: "droneFilled",
  droneOutlined: "droneOutlined",
  dvrFilled: "dvrFilled",
  dvrOutlined: "dvrOutlined",
  editFilled: "editFilled",
  editOutlined: "editOutlined",
  emailFilled: "emailFilled",
  emailOutlined: "emailOutlined",
  emergencyContactFilled: "emergencyContactFilled",
  emergencyContactOutlined: "emergencyContactOutlined",
  energyManagementFilled: "energyManagementFilled",
  energyManagementOutlined: "energyManagementOutlined",
  engineFilled: "engineFilled",
  engineOutlined: "engineOutlined",
  ereaderFilled1: "ereaderFilled1",
  ereaderFilled: "ereaderFilled",
  errorFilled: "errorFilled",
  errorOutlined: "errorOutlined",
  ethernetOutlined: "ethernetOutlined",
  ethernetSwitchFilled: "ethernetSwitchFilled",
  ethernetSwitchOutlined: "ethernetSwitchOutlined",
  expand: "expand",
  extendedRealityFilled: "extendedRealityFilled",
  extendedRealityOutlined: "extendedRealityOutlined",
  externalLink: "externalLink",
  faceid: "faceid",
  fallbackFilled: "fallbackFilled",
  fallbackOutlined: "fallbackOutlined",
  familyFilled: "familyFilled",
  familyOutlined: "familyOutlined",
  favoriteFilled: "favoriteFilled",
  favoriteOutlined: "favoriteOutlined",
  filterCheckOutlined: "filterCheckOutlined",
  filter: "filter",
  fingerprint: "fingerprint",
  fireFilled: "fireFilled",
  fireOutlined: "fireOutlined",
  fiveGOutlined: "fiveGOutlined",
  flagFilled: "flagFilled",
  flagOutlined: "flagOutlined",
  flashlightOnFilled: "flashlightOnFilled",
  flashlightOnOutlined: "flashlightOnOutlined",
  flatTireFilled: "flatTireFilled",
  flatTireOutlined: "flatTireOutlined",
  formatListBulleted: "formatListBulleted",
  fpo: "fpo",
  gameConsoleFilled: "gameConsoleFilled",
  gameConsoleOutlined: "gameConsoleOutlined",
  gamesOffFilled: "gamesOffFilled",
  gamesOffOutlined: "gamesOffOutlined",
  garageOpenerFilled: "garageOpenerFilled",
  garageOpenerOutlined: "garageOpenerOutlined",
  gasFilled: "gasFilled",
  gasOutlined: "gasOutlined",
  genericActive: "genericActive",
  genericDisabled: "genericDisabled",
  genericFilled: "genericFilled",
  genericOutlined: "genericOutlined",
  giftOutlined: "giftOutlined",
  giftcard: "giftcard",
  googlepayActive: "googlepayActive",
  googlepayDisabled: "googlepayDisabled",
  guideFilled: "guideFilled",
  guideOutlined: "guideOutlined",
  hangUpFilled: "hangUpFilled",
  hangUpOutlined: "hangUpOutlined",
  harshBrakingFilled: "harshBrakingFilled",
  harshBrakingOutlined: "harshBrakingOutlined",
  headphonesFilled: "headphonesFilled",
  headphonesOutlined: "headphonesOutlined",
  healthDeviceFilled: "healthDeviceFilled",
  healthDeviceOutlined: "healthDeviceOutlined",
  helpCircleFilled: "helpCircleFilled",
  helpCircleOutlined: "helpCircleOutlined",
  homeFilled: "homeFilled",
  homeOutlined: "homeOutlined",
  homeinternetFilled: "homeinternetFilled",
  homeinternetOutlined: "homeinternetOutlined",
  id: "id",
  idlingFilled: "idlingFilled",
  idlingOutlined: "idlingOutlined",
  infoCircleFilled: "infoCircleFilled",
  infoCircleOutlined: "infoCircleOutlined",
  inviteFilled: "inviteFilled",
  inviteOutlined: "inviteOutlined",
  iosGpsCenteredFilled: "iosGpsCenteredFilled",
  iosGpsCenteredImpreciseFilled: "iosGpsCenteredImpreciseFilled",
  iosGpsLocationOffFilled: "iosGpsLocationOffFilled",
  iosGpsLocationOffOutlined: "iosGpsLocationOffOutlined",
  iosGpsNotcenteredImpreciseOutlined: "iosGpsNotcenteredImpreciseOutlined",
  iosGpsNotcenteredOutlined: "iosGpsNotcenteredOutlined",
  iotFilled: "iotFilled",
  iotOutlined: "iotOutlined",
  ipCameraOutlined: "ipCameraOutlined",
  keyFilled: "keyFilled",
  keyLockFilled: "keyLockFilled",
  keyLockOutlined: "keyLockOutlined",
  keyOutlined: "keyOutlined",
  kitchenApplianceFilled: "kitchenApplianceFilled",
  kitchenApplianceOutlined: "kitchenApplianceOutlined",
  languageEnglish: "languageEnglish",
  languageFrench: "languageFrench",
  languageGbEnglish: "languageGbEnglish",
  languageGlobal: "languageGlobal",
  languageSpanish: "languageSpanish",
  languageUs: "languageUs",
  laptopFilled: "laptopFilled",
  laptopOutlined: "laptopOutlined",
  lightingfilled: "lightingfilled",
  lightingOutlined: "lightingOutlined",
  lightningFilled: "lightningFilled",
  lightningOutlined: "lightningOutlined",
  likeFilled: "likeFilled",
  likeOutlined: "likeOutlined",
  listOutlined: "listOutlined",
  locationFilled: "locationFilled",
  locationOutlined: "locationOutlined",
  locationSharingFilled: "locationSharingFilled",
  locationSharingOutlined: "locationSharingOutlined",
  lockFilled: "lockFilled",
  lockOutlined: "lockOutlined",
  logoutOutlined: "logoutOutlined",
  lte: "lte",
  luggageFilled: "luggageFilled",
  luggageOutlined: "luggageOutlined",
  maliciousTrafficProtectionOutlined: "maliciousTrafficProtectionOutlined",
  mapFilled: "mapFilled",
  mapOutlined: "mapOutlined",
  mastercardActive: "mastercardActive",
  mastercardDisabled: "mastercardDisabled",
  menu: "menu",
  mergeFilled: "mergeFilled",
  mergeOutlined: "mergeOutlined",
  messagesFilled: "messagesFilled",
  messagesOutlined: "messagesOutlined",
  microphoneFilled: "microphoneFilled",
  microphoneOffFilled: "microphoneOffFilled",
  microphoneOffOutlined: "microphoneOffOutlined",
  microphoneOutlined: "microphoneOutlined",
  minimize: "minimize",
  minusCircleFilled: "minusCircleFilled",
  minusCircleOutlined: "minusCircleOutlined",
  minus: "minus",
  mobileAddFilled: "mobileAddFilled",
  mobileAddOutlined: "mobileAddOutlined",
  mobileCheck: "mobileCheck",
  mobileLocked: "mobileLocked",
  mobileOutlined: "mobileOutlined",
  mobile: "mobile",
  more: "more",
  movementOutlined: "movementOutlined",
  multiDevice: "multiDevice",
  multiplePinsFilled: "multiplePinsFilled",
  multiplePinsOutlined: "multiplePinsOutlined",
  myLocationFilled: "myLocationFilled",
  myLocationOutlined: "myLocationOutlined",
  nasStorageFilled: "nasStorageFilled",
  nasStorageOutlined: "nasStorageOutlined",
  networkDeviceFilled: "networkDeviceFilled",
  networkDeviceOutlined: "networkDeviceOutlined",
  notificationEditFilled: "notificationEditFilled",
  notificationEditOutlined: "notificationEditOutlined",
  notificationFilled: "notificationFilled",
  notificationOffFilled: "notificationOffFilled",
  notificationOffOutlined: "notificationOffOutlined",
  notificationOutlined: "notificationOutlined",
  nyceActive: "nyceActive",
  nyceDisabled: "nyceDisabled",
  oilFilled: "oilFilled",
  oilOutlined: "oilOutlined",
  oilTempFilled: "oilTempFilled",
  oilTempOutlined: "oilTempOutlined",
  orderFilled: "orderFilled",
  orderOutlined: "orderOutlined",
  orderReceivedFilled: "orderReceivedFilled",
  orderReceivedOutlined: "orderReceivedOutlined",
  otherFilled: "otherFilled",
  otherOutlined: "otherOutlined",
  packageFilled: "packageFilled",
  packageOutlined: "packageOutlined",
  passport: "passport",
  pause: "pause",
  personalMediaDevicesFilled: "personalMediaDevicesFilled",
  personalMediaDevicesOutlined: "personalMediaDevicesOutlined",
  petsFilled: "petsFilled",
  petsOutlined: "petsOutlined",
  phoneIncomingFilled: "phoneIncomingFilled",
  phoneIncomingOutlined: "phoneIncomingOutlined",
  phoneOffFilled: "phoneOffFilled",
  phoneOffOutlined: "phoneOffOutlined",
  phoneOutgoingFilled: "phoneOutgoingFilled",
  phoneOutgoingOutlined: "phoneOutgoingOutlined",
  planeFilled: "planeFilled",
  planeOutlined: "planeOutlined",
  playCircleFilled: "playCircleFilled",
  playCircleOutlined: "playCircleOutlined",
  play: "play",
  plusCircleFilled: "plusCircleFilled",
  plusCircleOutlined: "plusCircleOutlined",
  plus: "plus",
  portableMediaServerFilled: "portableMediaServerFilled",
  portableMediaServerOutlined: "portableMediaServerOutlined",
  portableMusicPlayerFilled: "portableMusicPlayerFilled",
  portableMusicPlayerOutlined: "portableMusicPlayerOutlined",
  powerOutlined: "powerOutlined",
  priceTagFilled: "priceTagFilled",
  priceTagOutlined: "priceTagOutlined",
  print: "print",
  printerFilled: "printerFilled",
  printerOutlined: "printerOutlined",
  processing: "processing",
  pulseActive: "pulseActive",
  pulseDisabled: "pulseDisabled",
  qrCodeOutlined: "qrCodeOutlined",
  rabbitFilled: "rabbitFilled",
  rabbitOutlined: "rabbitOutlined",
  radioSelected: "radioSelected",
  radioUnselected: "radioUnselected",
  radiusFilled: "radiusFilled",
  radiusOutlined: "radiusOutlined",
  rapidAccelerationOutlined: "rapidAccelerationOutlined",
  recentlyViewedOutlined: "recentlyViewedOutlined",
  recommendFilled: "recommendFilled",
  recommendOutlined: "recommendOutlined",
  recycling: "recycling",
  refreshFilled: "refreshFilled",
  reportFilled: "reportFilled",
  reportOutlined: "reportOutlined",
  restartOutlined: "restartOutlined",
  rewardFilled: "rewardFilled",
  rewardOutlined: "rewardOutlined",
  roaming: "roaming",
  robotFilled: "robotFilled",
  robotOutlined: "robotOutlined",
  rocketFilled: "rocketFilled",
  rocketOutlined: "rocketOutlined",
  routerFilled: "routerFilled",
  routerOutlined: "routerOutlined",
  safeBrowsingOutlined: "safeBrowsingOutlined",
  satelliteFilled: "satelliteFilled",
  satelliteOutlined: "satelliteOutlined",
  savingsFilled: "savingsFilled",
  savingsOutlined: "savingsOutlined",
  schoolModeFilled: "schoolModeFilled",
  schoolModeOffFilled: "schoolModeOffFilled",
  schoolModeOffOutlined: "schoolModeOffOutlined",
  schoolModeOutlined: "schoolModeOutlined",
  screenFilled: "screenFilled",
  screenOutlined: "screenOutlined",
  search: "search",
  seatbeltFilled: "seatbeltFilled",
  seatbeltOutlined: "seatbeltOutlined",
  security: "security",
  sendFilled: "sendFilled",
  sendOutlined: "sendOutlined",
  sensorOutlined: "sensorOutlined",
  serverFilled: "serverFilled",
  serverOutlined: "serverOutlined",
  serviceDeskFilled: "serviceDeskFilled",
  serviceDeskOutlined: "serviceDeskOutlined",
  setTopBoxFilled: "setTopBoxFilled",
  setTopBoxOutlined: "setTopBoxOutlined",
  settingSlidersOutlined: "settingSlidersOutlined",
  settingsFilled: "settingsFilled",
  settingsOutlined: "settingsOutlined",
  shareFilled: "shareFilled",
  shareOutlined: "shareOutlined",
  sharpCorneringFilled: "sharpCorneringFilled",
  sharpCorneringOutlined: "sharpCorneringOutlined",
  shippingFilled: "shippingFilled",
  shippingOutlined: "shippingOutlined",
  signalIssue: "signalIssue",
  signalOffOutlined: "signalOffOutlined",
  signal: "signal",
  simFilled: "simFilled",
  simcardOutlined: "simcardOutlined",
  smartHomeAutomationFilled: "smartHomeAutomationFilled",
  smartHomeAutomationOutlined: "smartHomeAutomationOutlined",
  smartTvFilled: "smartTvFilled",
  smartTvOutlined: "smartTvOutlined",
  smokeDetectorFilled: "smokeDetectorFilled",
  smokeDetectorOutlined: "smokeDetectorOutlined",
  socialFacebook: "socialFacebook",
  socialInstagram: "socialInstagram",
  socialTiktok: "socialTiktok",
  socialX: "socialX",
  socialYoutube: "socialYoutube",
  sosFilled: "sosFilled",
  sportsFitnessOutlined: "sportsFitnessOutlined",
  sprinklerSystemOutlined: "sprinklerSystemOutlined",
  starActive: "starActive",
  starDisabled: "starDisabled",
  starFilledHalf: "starFilledHalf",
  starFilled: "starFilled",
  starOutlined: "starOutlined",
  statusFalseFilled: "statusFalseFilled",
  statusFalseOutlined: "statusFalseOutlined",
  stepsFilled: "stepsFilled",
  stepsOutlined: "stepsOutlined",
  stopFilled: "stopFilled",
  storeFilled: "storeFilled",
  storeOutlined: "storeOutlined",
  streamingVideoDeviceFilled: "streamingVideoDeviceFilled",
  streamingVideoDeviceOutlined: "streamingVideoDeviceOutlined",
  suspiciousDeviceActivityOutlined: "suspiciousDeviceActivityOutlined",
  switcherOutlined: "switcherOutlined",
  tDigitLogo: "tDigitLogo",
  tabletOutlined: "tabletOutlined",
  tablet: "tablet",
  tasksOffFilled: "tasksOffFilled",
  tasksOffOutlined: "tasksOffOutlined",
  thermometerFilled: "thermometerFilled",
  thermostatFilled: "thermostatFilled",
  thermostatOutlined: "thermostatOutlined",
  threeSixty: "threeSixty",
  ticketFilled: "ticketFilled",
  ticketOutlined: "ticketOutlined",
  tirePressureOutlined: "tirePressureOutlined",
  touchFilled: "touchFilled",
  touchOutlined: "touchOutlined",
  towTruckFilled: "towTruckFilled",
  towTruckOutlined: "towTruckOutlined",
  toysFilled: "toysFilled",
  toysOutlined: "toysOutlined",
  translatorOutlined: "translatorOutlined",
  transmissionLteOutlined: "transmissionLteOutlined",
  trashcanFilled: "trashcanFilled",
  trashcanOutlined: "trashcanOutlined",
  tripOutlined: "tripOutlined",
  tripStartOutlined: "tripStartOutlined",
  trophyFilled: "trophyFilled",
  trophyOutlined: "trophyOutlined",
  turtleFilled: "turtleFilled",
  turtleOutlined: "turtleOutlined",
  unauthorizedAccessProtectionFilled: "unauthorizedAccessProtectionFilled",
  unauthorizedAccessProtectionOutlined: "unauthorizedAccessProtectionOutlined",
  unlinkOutlined: "unlinkOutlined",
  unlockFilled: "unlockFilled",
  unlockOutlined: "unlockOutlined",
  upgrade: "upgrade",
  usageFilled: "usageFilled",
  usageOutlined: "usageOutlined",
  userAdminFilled: "userAdminFilled",
  userAdminOutlined: "userAdminOutlined",
  userFilled: "userFilled",
  userOutlined: "userOutlined",
  userSettingsFilled: "userSettingsFilled",
  userSettingsOutlined: "userSettingsOutlined",
  ventFilled: "ventFilled",
  ventOutlined: "ventOutlined",
  verifiedFilled: "verifiedFilled",
  verifiedOutlined: "verifiedOutlined",
  videoFilled: "videoFilled",
  videoIncomingFilled: "videoIncomingFilled",
  videoIncomingOutlined: "videoIncomingOutlined",
  videoOffFilled: "videoOffFilled",
  videoOffOutlined: "videoOffOutlined",
  videoOutgoingFilled: "videoOutgoingFilled",
  videoOutgoingOutlined: "videoOutgoingOutlined",
  videoOutlined: "videoOutlined",
  virtualBoundariesFilled: "virtualBoundariesFilled",
  virtualBoundariesOutlined: "virtualBoundariesOutlined",
  visaActive: "visaActive",
  visaDisabled: "visaDisabled",
  visibilityOffFilled: "visibilityOffFilled",
  visibilityOffOutlined: "visibilityOffOutlined",
  visibilityOnFilled: "visibilityOnFilled",
  visibilityOnOutlined: "visibilityOnOutlined",
  volumeMuteFilled: "volumeMuteFilled",
  volumeMuteOutlined: "volumeMuteOutlined",
  volumeOffOutlined: "volumeOffOutlined",
  volumeUpFilled: "volumeUpFilled",
  volumeUpOutlined: "volumeUpOutlined",
  warningFilled: "warningFilled",
  warningOutlined: "warningOutlined",
  watchKidsOffOutlined: "watchKidsOffOutlined",
  watchKidsOutlined: "watchKidsOutlined",
  watchKidsSoundOutlined: "watchKidsSoundOutlined",
  watchOutlined: "watchOutlined",
  watch: "watch",
  wearablesFilled: "wearablesFilled",
  wearablesOutlined: "wearablesOutlined",
  webCamFilled: "webCamFilled",
  webCamOutlined: "webCamOutlined",
  webAssetOff: "webAssetOff",
  wifiCalling: "wifiCalling",
  wifiExtenderFilled: "wifiExtenderFilled",
  wifiExtenderOutlined: "wifiExtenderOutlined",
  wifiIssue: "wifiIssue",
  wifiSecureOutlined: "wifiSecureOutlined",
  wifi: "wifi",
  wirelessAudioFilled: "wirelessAudioFilled",
  wirelessAudioOutlined: "wirelessAudioOutlined",
  wrenchFilled: "wrenchFilled",
  wrenchOutlined: "wrenchOutlined",
  zoomIn: "zoomIn",
  zoomOut: "zoomOut",
};

export type Icon = (typeof Icons)[keyof typeof Icons];
